import { styled } from "@mui/material/styles";

export const CrossroadBadge = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderRadius: "50% !important",
  justifyContent: "center",
  position: "absolute",
  background: theme.palette.custom.green[800],
  width: "25px",
  height: "25px",
  fontWeight: "800",
  color: "white",
  top: "50%",
  left: "calc(-1 * var(--main-line-offset))",
  transform: "translate(-50%, -50%)",
  fontSize: "1.7rem",
  pointerEvents: "none",
  userSelect: "none",
}));
